import { PlanType } from 'api-validations/user-api'
import { generatePath, Navigate, Outlet } from 'react-router'
import { useOrgCodeOrThrow, useOrgInfo } from 'shared-ui/active-operation'
import { Loading } from 'shared-ui/components'
import { isNil } from 'utils'

import { path } from '../../../routes/paths'

/**
 * Route guard that restricts access to dealer orgs only.
 * Non-dealer orgs navigating to /dealer are redirected to /home.
 */
export const DealerOnlyGuard: React.FC = () => {
  const orgCode = useOrgCodeOrThrow()
  const orgInfo = useOrgInfo()

  if (isNil(orgInfo)) {
    return <Loading />
  }

  if (orgInfo.planType !== PlanType.Dealer) {
    return <Navigate to={generatePath(path.home, { orgCode })} replace />
  }

  return <Outlet />
}
